import baseClassNames, { Argument } from 'classnames'
import { twMerge } from 'tailwind-merge'

/**
 * A utility for conditionally joining classNames together.
 * Merges Tailwind CSS classes without style conflicts.
 *
 * @param args strings or objects to be flattened
 */
const classNames = (...args: Argument[]) => {
  return twMerge(baseClassNames(...args))
}

export default classNames
